module.exports = __webpack_public_path__ + "static/dokuwiki-f4617f6b03479daec78c48476596235a.png";